import React, { useState } from 'react';
import { components } from 'react-select';
import { OptionProps } from 'react-select';
import CheckboxComponent from '../CheckBox';
import './SearchableDropDownComponent.css';
interface OptionType {
  label: string;
  value: string;
}
const CustomOption: React.FC<OptionProps<OptionType>> = (props) => {
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxdropChange = (checked: boolean) => {
    setIsChecked(checked);
  };
  return (
    <components.Option {...props}>
      <div className="checkbox-index-dropdown">
        <CheckboxComponent
          isChecked={props.isSelected}
          onCheckboxChange={handleCheckboxdropChange}
          disabled={false}
          className={''}
        />
        <label className="checkbox-index-dropdown-label">{props.label}</label>
      </div>
    </components.Option>
  );
};

export default CustomOption;
